import { AlertOctagon, History, UserCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";

export const REASON_LABELS = {
  ai_uncertain: "AI Uncertain",
  user_requested_representative: "User Request",
};

export const EscalatedThreadsCard = ({ escalatedThreads, onViewHistory, onResolve }) => {
  if (!escalatedThreads.length) return null;
  return (
          <Card className="border-red-200 bg-red-50" data-testid="escalated-threads-card">
            <CardHeader>
              <CardTitle className="text-lg flex items-center gap-2 text-red-700">
                <AlertOctagon className="w-5 h-5 text-red-500" />
                Threads Needing Human Attention ({escalatedThreads.length})
              </CardTitle>
              <CardDescription className="text-red-600">
                These conversations require a human response - auto-responder is paused
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {escalatedThreads.slice(0, 5).map((thread) => (
                  <div 
                    key={thread.thread_id}
                    className="flex items-center justify-between p-3 rounded-lg bg-white border border-red-100"
                  >
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <Badge variant="outline" className="text-xs border-red-200 text-red-600">
                          {REASON_LABELS[thread.reason] || thread.reason}
                        </Badge>
                        <span className="text-xs text-slate-500">
                          Thread: {thread.thread_id?.slice(0, 12)}...
                        </span>
                      </div>
                      {thread.original_message && (
                        <p className="text-sm text-slate-700 mt-1 line-clamp-1">
                          {thread.original_message}
                        </p>
                      )}
                      <p className="text-xs text-slate-500 mt-1">
                        Escalated: {new Date(thread.escalated_at).toLocaleString()}
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        variant="outline"
                        className="gap-1"
                        onClick={() => onViewHistory(thread.thread_id)}
                        data-testid={`view-history-${thread.thread_id}`}
                      >
                        <History className="w-3 h-3" />
                        View
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        className="gap-1 border-emerald-200 text-emerald-600 hover:bg-emerald-50"
                        onClick={() => onResolve(thread.thread_id)}
                        data-testid={`resolve-${thread.thread_id}`}
                      >
                        <UserCheck className="w-3 h-3" />
                        Resolve
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
  );
};
